// extracted by mini-css-extract-plugin
export var container = "_lx-0";
export var dotAnimation = "_lx-2";
export var dotsLoading = "_lx-1";